import List from '../../pages/Blog/Rankings/List';
import Detail from '../../pages/Blog/Rankings/Detail';
import Create from '../../pages/Blog/Rankings/Create';

export const subRoutesRankings = [
    {
        path: "",
        component: List,
        exact: true,
    }
].map((item) => {
    return {
        ...item,
        path: `/rankings${item.path}`,
        private: true
    };
});

export const routesRankings = [
    {
        path: "/create",
        component: Create,
        exact: true
    },
    {
        path: "/:elementId",
        component: Detail,
    }
].map((item) => {
    return {
        ...item,
        path: `/rankings${item.path}`,
        private: true
    };
});